import { Outlet } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { ThemeDiscoveryHint } from '@/components/theme/ThemeDiscoveryHint';
import { LoginIllustration } from '../components/LoginIllustration';

export function AuthLayout() {
  return (
    // ONE unified surface (86d3cff1t) — no full-height seam. The two columns
    // are centered together as a tight group with a SHORT middle divider for
    // gentle separation; the brand mark lives at the illustration core, so
    // there is no separate logo header to duplicate it. Stacks on mobile.
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background px-6 py-10">
      {/* Decorative backdrop — faint engineering grid + soft brand glow
          (86d3cff1t). Behind everything, non-interactive. */}
      <div className="auth-backdrop pointer-events-none absolute inset-0" aria-hidden="true" />

      {/* Theme switcher, surfaced pre-login (86d3buh1u). Wrapped in its own
          TooltipProvider (there is no global one) and in the one-time discovery
          hint. */}
      <TooltipProvider>
        <div className="absolute right-4 top-4 z-10">
          <ThemeDiscoveryHint side="bottom" align="end">
            <ThemeToggle />
          </ThemeDiscoveryHint>
        </div>
      </TooltipProvider>

      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center gap-10 lg:flex-row lg:justify-center lg:gap-12">
        {/* Brand column — illustration with the Capitol Steel logo at the core,
            daily operations connected around it along ribbed (deformed-bar)
            links. */}
        <div className="flex w-full max-w-sm flex-col items-center text-center">
          <LoginIllustration className="h-auto w-full max-w-sm" />
          <div className="mt-4">
            <h1 className="text-2xl font-bold text-foreground">Capitol Steel</h1>
            <p className="mt-1 text-sm font-medium text-muted-foreground">
              Digital Operations Platform
            </p>
            <p className="mt-3 text-sm text-muted-foreground">
              The digital backbone of Capitol Steel — connecting people,
              materials, and decisions into one system that runs every day's
              operations.
            </p>
          </div>
        </div>

        {/* Short middle divider — enough to emphasize the split, not a
            full-height seam. */}
        <div className="hidden h-64 w-px shrink-0 bg-border lg:block" />

        {/* Form column — cardless sign-in on the same surface. */}
        <div className="w-full max-w-sm">
          <Outlet />

          <p className="mt-8 text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Capitol Steel Corporation. All
            rights reserved.
          </p>
          <p className="mt-1 text-xs text-muted-foreground/70">
            v{__APP_VERSION__}
          </p>
        </div>
      </div>
    </div>
  );
}
